import { render, staticRenderFns } from "./attendee-limit-field.vue?vue&type=template&id=60f0d6b0&scoped=true"
import script from "./attendee-limit-field.vue?vue&type=script&lang=js"
export * from "./attendee-limit-field.vue?vue&type=script&lang=js"
import style0 from "./attendee-limit-field.vue?vue&type=style&index=0&id=60f0d6b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f0d6b0",
  null
  
)

export default component.exports